// extracted by mini-css-extract-plugin
export var redoItem = "_ot-1";
export var redoTrigger = "_ot-0";